import useCustomerClientKeyFobStats from "./index.hook";
import styles from "./index.module.less";

type CustomerClientKeyFobStatsProps = {
  handleCustomerClientId: (value: number | null) => void;
  customerClientId: number | null;
};
const CustomerClientKeyFobStats = (props: CustomerClientKeyFobStatsProps) => {
  const config = useCustomerClientKeyFobStats({ customerClientId: props.customerClientId });

  return (
    <div className={styles["container"]}>
      <div className={styles["flex-container"]}>
        <div>
          <h5 style={{ display: "inline" }}>Allocated Parking:</h5> {!config.loading ? config?.customerClientKeyFobStats?.allocatedParking : ""}
        </div>
        <div>
          <h5 style={{ display: "inline" }}> Allocated KeyFob: </h5>
          {!config.loading ? config?.customerClientKeyFobStats?.allocatedKeyFob : ""}
        </div>
        <div>
          <h5 style={{ display: "inline" }}>Available KeyFob:</h5> {!config.loading ? config?.customerClientKeyFobStats?.availableKeyFob : ""}
        </div>
      </div>
      <span className={styles["span"]}>(incl. family members)</span>
    </div>
  );
};

export default CustomerClientKeyFobStats;
